import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './RegisterScreen.css'
import { useTranslation } from 'react-i18next';
import { submitFormData } from '../utils/api';
import { URL } from '../utils/constants';
import check from '../assets/icons/check.png'
import { calcFontSize } from '../utils/common';

const RegisterScreen = ({ show, onClose, source }) => {
  const { t } = useTranslation();
  
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);

  const [formData, setFormData] = useState({
    telefono: '',
    email: '',
    emailcheck: '',
    nombre: '',
    rol: '',
    recaptcha: '',
    formType: [],
    texto: '', // Nuevo campo para comentarios FPN59
   /*  source: source, */
  });

  const [formErrors, setFormErrors] = useState({
    telefono: false,
    email: false,
    emailcheck: false,
    nombre: false,
    rol: false,
    recaptcha: true,
    texto: false, // Error de validación para comentarios FPN59
  });

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location);
    
    const isFormValid = Object.values(formData).every(value => value !== '');
    const isEmailsMatch = formData?.email === formData?.emailcheck;
    const isTelefonoValid = validateTelefono(formData?.telefono);
    const isFormTypeValid = formData.formType?.length > 0;
    const isCommentsValid = validateComments(formData.texto);
    setIsSubmitDisabled(
      !(isFormValid && isEmailsMatch && isTelefonoValid && isFormTypeValid && isCommentsValid)
    );
  }, [formData]);

  const validateTelefono = (telefono) => {
    const telefonoRegex = /^[0-9]{9}$/; // Cambia esta expresión regular según el formato de teléfono que necesites
    return telefonoRegex.test(telefono);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

 /*  const validateComments = (texto) => {
    return texto.trim().length > 0 && texto.trim().length <= 150;
  }; */
  const validateComments = (texto) => {
    const words = texto.trim().split(/\s+/); // Divide el texto por espacios en blanco y otros delimitadores
    
    return words.length <= 150;
  };


  /* const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'telefono') {
      setFormErrors({
        ...formErrors,
        telefono: !validateTelefono(value),
      });
    }

    if (name === 'email') {
        setFormErrors({
          ...formErrors,
          email: !validateEmail(value),
        });
      }

      if (name === 'emailcheck') {
        setFormErrors({
          ...formErrors,
          emailcheck: value !== formData?.email,
        });
      }

      if (name === 'texto') {
        setFormErrors({
          ...formErrors,
          //texto: value.trim().length >= 150,
          texto: !validateComments(value),
        });
      }
  }; */
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Solo validar el campo 'texto'
    if (name === 'texto') {
      const words = value.trim().split(/\s+/); // Divide el texto por espacios
  
      if (words.length <= 150) {
        // Si el número de palabras es menor o igual a 150, actualizamos el estado
        setFormData({
          ...formData,
          [name]: value,
        });
        setFormErrors({
          ...formErrors,
          texto: false, // Limpiar el error si es válido
        });
      } else {
        // Si se supera el límite de palabras, no permitir más cambios
        setFormErrors({
          ...formErrors,
          texto: true, // Error de exceso de palabras
        });
      }
    } else {
      // Actualizamos otros campos sin validaciones adicionales
      setFormData({
        ...formData,
        [name]: value,
      });
  
      if (name === 'telefono') {
        setFormErrors({
          ...formErrors,
          telefono: !validateTelefono(value),
        });
      }
  
      if (name === 'email') {
        setFormErrors({
          ...formErrors,
          email: !validateEmail(value),
        });
      }
  
      if (name === 'emailcheck') {
        setFormErrors({
          ...formErrors,
          emailcheck: value !== formData?.email,
        });
      }
    }
  };

  const handleCheckChange = (e) => {
    setFormData({
      ...formData,
      rol: e.target.value,
    });
  };
  const handleCheckChangeFormType = (e) => {
    const { value, checked } = e.target;
  
    setFormData((prevFormData) => {
      // Ensure prevFormData.formType is always an array
      const currentFormType = prevFormData?.formType || [];
  
      const newFormType = checked
        ? [...currentFormType, value] // Add value if checked
        : currentFormType.filter((type) => type !== value); // Remove value if unchecked
  
      return {
        ...prevFormData,
        formType: newFormType,
      };
    });
  };

  const handleRecaptchaChange = (value) => {
    setFormData({
      ...formData,
      recaptcha: value,
    });
    setFormErrors({
      ...formErrors,
      recaptcha: value === null,
    });
  };

  const handleCancel = () => {
    onBack();
    setFormData({
        telefono: '',
        email: '',
        emailcheck: '',
        nombre: '',
        rol: '',
        recaptcha: '',
        texto: ''
    });
    setFormErrors({
        telefono: false,
        email: false,
        emailcheck: false,
        nombre: false,
        rol: false,
        recaptcha: true,
    })
  };

  const onBack = () => {
    window.history.back();
  }

  /* const handleSubmit = () => {
     
    const postParam = {
      email: formData?.email,
      name: formData?.nombre,
      formType: formData?.formType,
      rol: formData?.rol,
      phone: formData?.telefono
    }

    console.log('params', postParam);

    onClose();
    setFormData({
      telefono: '',
      email: '',
      emailcheck: '',
      nombre: '',
      rol: '',
      recaptcha: '',
      formType: [],
    });
  }; */
  const mapFormTypeToEnglish = (formType) => {
    return formType.map(type => {
      if (type === t("modal.formTypeAlerts")) {
        return "alerts";
      } else if (type === t("modal.formTypeTrip")) {
        return "tripupdates";
      }
      return type.toLowerCase();
    });
  };

  const mapRoleToEnglish = (role) => {
    if (role === t("modal.rolOperator")) {
      return "operator";
    } else if (role === t("modal.rolAdmin")) {
      return "administrator";
    } else if (role === t("modal.rolOthers")) {
      return "others";
    }
    return role.toLowerCase();
  };

  const handleSubmit = async () => {
    const mappedFormType = mapFormTypeToEnglish(formData?.formType);
    const mappedRole = mapRoleToEnglish(formData?.rol);
    
    try {
      await submitFormData({
        telefono: formData?.telefono,
        email: formData?.email,
        nombre: formData?.nombre,
        rol: mappedRole,
        formType: mappedFormType,
        texto: formData?.texto,
      });
   
      console.log('Solicitud POST exitosa');
      setShowThankYouMessage(true);
      setTimeout(() => {
        setShowThankYouMessage(false);
        onBack();
        setFormData({
          telefono: '',
          email: '',
          emailcheck: '',
          nombre: '',
          rol: '',
          recaptcha: '',
          formType: [],
          texto: '',
        });
       
      }, 4000);
    } catch (error) {
      console.error('Error al enviar la solicitud POST:', error);
    }}

  

  const handleClearInput = (field) => {
    setFormData({
      ...formData,
      [field]: '',
    });
    setFormErrors ({
      ...formErrors,
      [field]: false,
    })

   /*  if (field === 'telefono') {
      setFormErrors({
        ...formErrors,
        telefono: true,
      });
    } */
  };
  /* const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  }; */

  
const primary = localStorage.getItem('PRIMARY_COLOR')
 
  return (
    <div role="dialog" aria-label="form-title" /* aria-describedby="form-description" */ className="modal-backdrop-formScreen" /* onClick={handleBackdropClick} */>
      <div className={showThankYouMessage ? "modal-contentThanksScreen" :  "modal-contentScreen"} >
      {showThankYouMessage ? (
       <div aria-live="polite" className="thank-you-message">
        <img className='iconoCheck' src={check} alt="check" />
         <h2 style={{ fontSize:calcFontSize(24)}}>{t("modal.thankYouMessage")}</h2>
       </div>
     ) : (
      <>
       <div style={{ background: primary === '#009989' ? 'linear-gradient(90deg, rgba(0,152,137,1) 35%, rgba(146,195,67,1) 100%)': 'linear-gradient(90deg, rgba(0, 102, 92, 1)  35%, rgba(0,152,137,1) 100%)'}} className='titleH2Screen'>
          <h2 style={{ fontSize:calcFontSize(24)}} className='titleScreen'>{t("modal.title")}{/*  / {source} */}
          </h2>
        </div>
        <form className='formContainerScreen'>
          <div className="div1ModalScreen">
          <div className="radio-container">
    <div className='divInput'>
      <input
        type="checkbox"
        id="alertes"
        name="formType"
        value={t("modal.formTypeAlerts")}
        checked={formData.formType?.includes(t("modal.formTypeAlerts"))}
        onChange={handleCheckChangeFormType}
      />
      <label style={{ fontSize:calcFontSize(12)}} className='labelStyleUp' htmlFor="alertes">{t("modal.formTypeAlerts")}</label>
    </div>
    <div className='divInput'>
      <input
        type="checkbox"
        id="tripupdates"
        name="formType"
        value={t("modal.formTypeTrip")}
        checked={formData.formType?.includes(t("modal.formTypeTrip"))}
        onChange={handleCheckChangeFormType}
      />
      <label style={{ fontSize:calcFontSize(12)}} className='labelStyleUp' htmlFor="tripupdates">{t("modal.formTypeTrip")}</label>
    </div>
  </div>
            <label style={{ fontSize:calcFontSize(16)}} htmlFor="telefono">{t("modal.telephone")}</label>
            <div className="input-containerScreen">
              <input
                type="text"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                aria-describedby={formErrors.telefono ? "error-telefono" : undefined}
                
              />
              <span
              role="button"
              tabIndex="0"
                className="clear-buttonScreen"
                onClick={() => handleClearInput('telefono')}
                aria-live="assertive"
                /* tabIndex={0} */
                aria-label={t(t("modal.clearButtonPhone"))}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleClearInput('telefono');
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </span>
            </div>
            {formErrors.telefono && <span style={{ fontSize:calcFontSize(12)}} className="error" aria-live="assertive">{t("modal.telephoneError")}</span>}
          </div>
          <div className="div2ModalScreen">
          <div className="radio-container2">

        </div>
            <label style={{ fontSize:calcFontSize(16)}} htmlFor="email">{t("modal.email")}</label>
            <div className="input-containerScreen">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                aria-describedby={formErrors.emailcheck ? "error-emailcheck" : undefined}
              />
              <span
              role="button"
                className="clear-buttonScreen"
                onClick={() => handleClearInput('email')}
                aria-live="assertive"
                tabIndex={0}
                aria-label={t(t("modal.clearButtonEmail"))}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleClearInput('email');
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </span>
            </div>
            {formErrors.email && <span style={{ fontSize:calcFontSize(12)}} className="error" aria-live="assertive">{t("modal.emailError")}</span>}
          </div>
          <div className="div3ModalScreen">
            {/* <label>Rol:</label> */}
            <div className='divInput'>
              <input
                type="checkbox"
                id="operador"
                name="rol"
                value={t("modal.rolOperator")}
                checked={formData?.rol === t("modal.rolOperator")}
                onChange={handleCheckChange}
                tabIndex="0"
                
              />
              <label style={{ fontSize:calcFontSize(10)}} className='labelStyle' htmlFor="operador">{t("modal.rolOperator")}</label>
            </div>
            <div className='divInput'>
              <input
                type="checkbox"
                id="administracion"
                name="rol"
                value={t("modal.rolAdmin")}
                checked={formData.rol === t("modal.rolAdmin")}
                onChange={handleCheckChange}
                tabIndex="0"
                
              />
              <label style={{ fontSize:calcFontSize(10)}} className='labelStyle' htmlFor="administracion">{t("modal.rolAdmin")}</label>
            </div>
            <div className='divInput'>
              <input
                type="checkbox"
                id="altres"
                name="rol"
                value={t("modal.rolOthers")}
                checked={formData.rol === t("modal.rolOthers")}
                onChange={handleCheckChange}
                tabIndex="0"
                
              />
              <label style={{ fontSize:calcFontSize(10)}} className='labelStyle' htmlFor="altres">{t("modal.rolOthers")}</label>
            </div>
            {/* {formErrors.rol && <span className="error">Rol es requerido.</span>} */}
          </div>
          <div className="div4ModalScreen">
            <label style={{ fontSize:calcFontSize(16)}} htmlFor="emailcheck">{t("modal.checkEmail")}</label>
            <div className='input-containerScreen'>
              <input
                type="email"
                id="emailcheck"
                name="emailcheck"
                value={formData.emailcheck}
                onChange={handleChange}
                aria-describedby={formErrors.emailcheck ? "error-emailcheck" : undefined}
                
              />
              <span
              role="button"
                className="clear-buttonScreen"
                onClick={() => handleClearInput('emailcheck')}
                aria-live="assertive"
                tabIndex={0}
                aria-label={t(t("modal.clearButtonEmailCheck"))}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleClearInput('emailcheck');
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </span>
            </div>
            {formErrors.emailcheck && <span style={{ fontSize:calcFontSize(12)}} className="error" aria-live="assertive">{t("modal.checkEmailError")}</span>}
          </div>
          <div className="div5ModalScreen">
            <label style={{ fontSize:calcFontSize(16)}} htmlFor="nombre">{t("modal.name")}</label>
            <div className='input-containerScreen'>
                <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                />
                <span
                role="button"
                className="clear-buttonScreen"
                onClick={() => handleClearInput('nombre')}
                aria-live="assertive"
                tabIndex={0}
                aria-label={t(t("modal.clearButtonName"))}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleClearInput('nombre');
                  }
                }}
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="green"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                </span>
            </div>

            <div className="divComments">
                <label style={{ fontSize:calcFontSize(10)}} htmlFor="comments">{t("modal.commentsError")}</label>
                <textarea
                  id={formErrors.texto ? 'commentsError' : 'comments'}
                  name="texto"
                  value={formData.texto}
                  onChange={handleChange}
                  rows="4"
                  /* maxLength="150" */
                  className={formErrors.texto ? "error-input" : ""}
                 
                />
                {/* {formErrors.texto && (
                  <span className="error">{t("modal.commentsError")}</span>
                )} */}
                {formErrors.texto && (
                  <div style={{ marginTop: '20px' }}>
                        <span style={{ fontSize: calcFontSize(12) }} className="error" aria-live="assertive">
                        {t("modal.commentsTooLong")} 
                        </span>
                  </div>
                  
                  )}
              </div>
            {/* <div className="radio-container">
                <div className='divInput'>
                <input
                    type="radio"
                    id="alertes"
                    name="rol"
                    value="ALERTES"
                    checked={formData.rol === 'ALERTES'}
                    onChange={handleCheckChange}
                />
                <label className='labelStyle' htmlFor="alertes">Alertes</label>
                </div>
                <div className='divInput'>
                <input
                    type="radio"
                    id="tripupdates"
                    name="rol"
                    value="TRIPUPDATES"
                    checked={formData.rol === 'TRIPUPDATES'}
                    onChange={handleCheckChange}
                />
                <label className='labelStyle' htmlFor="tripupdates">Tripupdates</label>
                </div>
            </div> */}
    </div>
          <div className="div6ModalScreen">
            <ReCAPTCHA
            className='captcha'
              sitekey={URL?.recaptcha_key}/* "6Lf3TOMUAAAAABMDkA42oQEZYfP8L2W_jzAtQuAJ" */
              onChange={handleRecaptchaChange}
            />
            {/* {formErrors.recaptcha && <span className="error">Captcha es requerido.</span>} */}
          </div>
          <div className="div7ModalScreen buttonsScreen">
            <button style={{ fontSize:calcFontSize(13)}} className="buttonBack" type="button" onClick={handleCancel}>{t("modal.backButton")}</button>
            <button style={{ fontSize:calcFontSize(13)}} className="buttonSendScreen" type="button" onClick={handleSubmit} disabled={isSubmitDisabled}>
              {t("modal.submitButton")}
            </button>
          </div>
          
        </form>
      </>
     )}
       
      </div>
    </div>
  );
};

export default RegisterScreen;